import { AxiosResponse } from "axios";
import { paymentClient } from "../apiClient";

export const PayWithPremiumCode = async (premiumCode: string): Promise<any> => {
    try {
        const response: AxiosResponse<any> = await paymentClient().post('/payment/withPremiumCode', {
            premiumCode
        });
        return response.data;
    } catch (error) {
        console.error('Error submit premium code:', error);
        throw new Error('Failed to submit premium code');
    }
}